  //The below useEffect takes urlQuery params and parses into somthing the filters and chip ui can understand
    // This should probably be handled in a more elegant way.
  
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    const formatCurrency = (value) => {
      if (!value) value = 0;
      return formatter.format(value);
    };

    const formatDate = (value) => {
      if (!value) value = new Date();
      return new Date(value).toLocaleDateString();
    };
    
  
  export default function parseFromQueryParamstoUIState(filters, newUI){
    for (let param of filters) {
      let key = param[0];
      let keyWithoutLookUp = key;
  
      if (key.endsWith("__in")) {
        keyWithoutLookUp = key.slice(0, -4);
      }
      if (key.endsWith("__gte") || key.endsWith("__lte")) {
        keyWithoutLookUp = key.slice(0, -5);
      }
      if (newUI[keyWithoutLookUp]) {
        if (newUI[keyWithoutLookUp].filterType === "MultiSelectSearch") {
          newUI[keyWithoutLookUp].selectedValue = param[1].split(",");
          newUI[keyWithoutLookUp].activeChip.isActive = true;
          let label="";
          //set label if in localstorage
          if (localStorage.getItem(keyWithoutLookUp)) {
            label = localStorage.getItem(keyWithoutLookUp);
            
          } else {
            label = param[1].split(",");
          }
          newUI[keyWithoutLookUp].activeChip.label = label;
  
        }
        if (
          newUI[keyWithoutLookUp].filterType === "RangeSlider" ||
          newUI[keyWithoutLookUp].filterType === "DateRange"
        ) {
          let formattedParam =
            newUI[keyWithoutLookUp].filterType === "DateRange"
              ? new Date(param[1])
              : param[1];
          if (key.endsWith("__lte")) {
            newUI[keyWithoutLookUp].currentValues.__lte = formattedParam;
          }
          if (key.endsWith("__gte")) {
            newUI[keyWithoutLookUp].currentValues.__gte = formattedParam;
          }
  
          newUI[keyWithoutLookUp].activeChip.isActive = true;
          //setting chip labels strings
          if (newUI[keyWithoutLookUp].filterType === "RangeSlider") {
            newUI[keyWithoutLookUp].activeChip.label =
            formatCurrency(
                newUI[keyWithoutLookUp].currentValues.__gte
              ) +
              " - " +
              formatCurrency(newUI[keyWithoutLookUp].currentValues.__lte);
          }
          if (newUI[keyWithoutLookUp].filterType === "DateRange") {
            newUI[keyWithoutLookUp].activeChip.label =
            formatDate(newUI[keyWithoutLookUp].currentValues.__gte)  +
              " - " +
            formatDate(newUI[keyWithoutLookUp].currentValues.__lte);
          }
        }
        if (
          newUI[keyWithoutLookUp].filterType === "DatePicker" ||
          newUI[keyWithoutLookUp].filterType === "SearchOptionGroup" ||
          newUI[keyWithoutLookUp].filterType === "Search" ||
          newUI[keyWithoutLookUp].filterType === "SingleSelect"
        ) {
          newUI[keyWithoutLookUp].selectedValue = param[1];
          newUI[keyWithoutLookUp].activeChip.isActive = true;
          newUI[keyWithoutLookUp].activeChip.label = param[1];
          let label="";
          //set label if in localstorage
          if (localStorage.getItem(keyWithoutLookUp)) {
            label = localStorage.getItem(keyWithoutLookUp);
            
          } else {
            label = param[1];
          }
          newUI[keyWithoutLookUp].activeChip.label = label;
        }
      }
    }
    return newUI;
  }